<template>
  <div id="viewImage" v-show="showImage">
    <div class="image-preview-container">
      <img :src="url" class="preview-image"/>
      <span @click="closeImage" class="el-icon-close close-icon"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewImage',
  data() {
    return {
      url: '',
      showImage: false
    }
  },
  methods: {
    open(url) {
      this.url = url
      this.showImage = true
      this.launchIntoFullscreen()
    },
    closeImage() {
      this.exitFullscreen()
      this.showImage = false
    },
    launchIntoFullscreen() {
      const element = document.getElementById("viewImage")
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
    },
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    }
  },
  mounted() {
    document.addEventListener("fullscreenchange", (e) => {
      console.log(e)
      if (!document.fullscreenElement) {
        this.showImage = false
      }
    })
  }
}
</script>

<style scoped>
#viewImage {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-preview-container {
  position: relative;
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
}

.preview-image {
  max-width: 80vw;
  max-height: 80vh;
  display: block;
}

.close-icon {
  position: absolute;
  right: 20px;
  top: 20px;
  font-size: 20px;
  color: red;
  cursor: pointer;
}
</style>